"use client";

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
  useTheme,
} from "next-themes";
import { useMemo } from "react";

export function ShadcnThemeProvider({
  children,
  ...props
}: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}

export function useIsDarkTheme() {
  const { theme, systemTheme } = useTheme();

  // Determines if the theme is set to dark or the system theme is dark when the theme is set to 'system'
  const isDarkTheme = useMemo(
    () => theme === "dark" || (theme === "system" && systemTheme === "dark"),
    [theme, systemTheme],
  );

  return isDarkTheme;
}
